var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_5772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2957 16.4868C28.8297 15.6908 20.0766 21.2608 19.2809 23.6486M19.2809 33.1979C21.8463 34.373 25.6468 41.951 20.4673 45.4604C17.5874 47.281 12.8503 50.5648 18.1335 50.5251H44.45C45.592 49.4492 47.4888 45.808 45.9396 39.8495C44.3904 33.8911 36.0881 30.559 34.3999 29.2184C32.7117 27.8777 33.0793 22.8525 36.7871 21.8252M28.8297 38.7681C29.6255 41.1553 29.6255 43.542 28.034 45.4604M29.6255 22.8533C28.034 23.649 25.6468 26.0363 24.0553 28.4235",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38532 35.8255C7.33296 34.7 3.66521 31.0488 5.41302 25.4479C7.16083 19.847 9.98113 16.262 12.4142 16.262C14.8472 16.262 19.6289 21.7398 20.1601 27.583C20.5574 31.9525 16.3368 36.1731 13.7052 36.1234",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7122 26.49V31.7533M12.7122 41.7833V31.7533M12.7122 31.7533L9.23645 28.2775",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8132 20.9315C44.8655 19.806 48.5333 16.1548 46.7855 10.5539C45.0377 4.95292 42.2174 1.36792 39.7843 1.36792C37.3513 1.36792 32.5695 6.84575 32.0383 12.689C31.6411 17.0585 35.8617 21.2791 38.4933 21.2294",
    stroke: "#D34646",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4863 11.5957V16.859M39.4863 26.889V16.859M39.4863 16.859L42.962 13.3832",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_5772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrook);
export default __webpack_public_path__ + "static/media/Brook.0be46c290cf2a73d9dfec9ae3f059f0a.svg";
export { ForwardRef as ReactComponent };